export const calculateProgress = (currentStep: number, totalSteps: number) => {
  const stepsInMainApp = 3

  const progress = (currentStep / (totalSteps + stepsInMainApp)) * 100
  return progress
}
